export default __webpack_public_path__ + "static/media/logo.d480af13.svg";